import React from "react";
import SharedEntityForm from "../../../components/EntityForm";
import { TABLE_QAM_ENTITIES } from "./methods";
import { MODAL_QAM_ENTITY } from "./index";

const EntityForm = ({ name }) => (
  <SharedEntityForm name={name} defaultModalName={MODAL_QAM_ENTITY} tableName={TABLE_QAM_ENTITIES} />
);

export default EntityForm;
